import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@shared/components/ui/shadcn/dialog';
import { useTranslation } from 'react-i18next';
import type { ProfitabilitySummaryBreakdownQuery } from '../../models/Profitability';
import { ProfitabilitySummaryCogsTable } from '../display/ProfitabilitySummaryCogsTable';

interface ProfitabilitySummaryCogsModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  filters?: ProfitabilitySummaryBreakdownQuery;
  locale: string;
}

export const ProfitabilitySummaryCogsModal = ({
  open,
  onOpenChange,
  filters,
  locale,
}: ProfitabilitySummaryCogsModalProps) => {
  const { t } = useTranslation('profitabilityModule');

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="max-h-[90vh] max-w-[min(96vw,64rem)] overflow-y-auto border-border bg-background"
        data-testid="profitability-summary-cogs-modal"
      >
        <DialogHeader>
          <DialogTitle>{t('summary.cogs.title')}</DialogTitle>
        </DialogHeader>

        <p className="text-sm text-muted-foreground">{t('summary.cogs.hint')}</p>

        {open && <ProfitabilitySummaryCogsTable filters={filters} locale={locale} embedded enabled={open} />}
      </DialogContent>
    </Dialog>
  );
};
